import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyBMKu5m5ALdd0jeiCrPyi_zl9iC_HT4U3I",
    authDomain: "bpnpshuttle.firebaseapp.com",
    projectId: "bpnpshuttle",
    storageBucket: "bpnpshuttle.firebasestorage.app",
    messagingSenderId: "956435208567",
    appId: "1:956435208567:web:b6bc88dfb65961baffa972",
    measurementId: "G-1C7EP0YB26"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
